<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>Activity Guidance</md-icon>
                    </div>
                    <h4 class="title">Add Activity Guidance</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                               Labourer Count
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="activityGuidance.labourer_count"/>
                                    <validation-error :errors="apiValidationErrors.labourer_count"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                               Request Type
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="activityGuidance.request_type"/>
                                    <validation-error :errors="apiValidationErrors.request_type"/>
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                 Activity
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="activityGuidance.activity_id" name="activity_id">
                                        <md-option
                                                v-for="activity in available_activities_dropdown"
                                                :key="activity.id"
                                                :value="activity.id"
                                        >
                                            {{ activity.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                 Shift
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="activityGuidance.shift_id" name="shift_id">
                                        <md-option
                                                v-for="shift in available_shifts_dropdown"
                                                :key="shift.id"
                                                :value="shift.id"
                                        >
                                            {{ shift.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                 Work Place
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="activityGuidance.workplace_id" name="workplace_id">
                                        <md-option
                                                v-for="workplace in available_workplaces_dropdown"
                                                :key="workplace.id"
                                                :value="workplace.id"
                                        >
                                            {{ workplace.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                 Guidance
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="activityGuidance.guidance_id" name="guidance_id">
                                        <md-option
                                                v-for="guidance in available_guidances_dropdown"
                                                :key="guidance.id"
                                                :value="guidance.id"
                                        >
                                            {{ guidance.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                 Vessel
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="activityGuidance.vessel_id" name="vessel_id">
                                        <md-option
                                                v-for="vessel in available_vessels_dropdown"
                                                :key="vessel.id"
                                                :value="vessel.id"
                                        >
                                            {{ vessel.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                 Activity Tariff
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="activityGuidance.activity_tariff_id" name="activity_tariff_id">
                                        <md-option
                                                v-for="activity_tariff in available_activity_tariffs_dropdown"
                                                :key="activity_tariff.id"
                                                :value="activity_tariff.id"
                                        >
                                            {{ activity_tariff.amount }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>

                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Activity Guidance</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({
        activityGuidance: {
            type: 'activityGuidances',
            labourer_count: null,
            request_type: null,
            vessel_id: null,
            shift_id: null,
            activity_id: null,
            guidance_id: null,
            activity_tariff_id: null,
            workplace_id: null,
        },
        available_vessels_dropdown: [],
        available_shifts_dropdown: [],
        available_activities_dropdown: [],
        available_guidances_dropdown: [],
        available_activity_tariffs_dropdown: [],
        available_workplaces_dropdown: [],
    }),
    created () {
        this.getVesselDropDowns();
        this.getShiftDropDowns();
        this.getActivityDropDowns();
        this.getGuidanceDropDowns();
        this.getWorkplaceDropDowns();
        this.getActivityTariffDropDowns();
    },
    methods: {
        async add () {
            try {
                await this.$store.dispatch('activityGuidances/add', this.activityGuidance);
                console.log(this.$store);
                this.notifySuccess('Activity Guidance added successfully.');

                //  this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },
        getVesselDropDowns () {
            console.log(this.$store.dispatch);
            this.$store.dispatch('vessels/list').then(() => {
                this.available_vessels_dropdown = this.$store.getters['vessels/dropdown'];
                if (this.available_vessels_dropdown && this.available_vessels_dropdown.length) {
                    this.activityGuidance.vessel_id = this.available_vessels_dropdown[0].id;
                }
            });
        },
        getShiftDropDowns () {
            this.$store.dispatch('shifts/list').then(() => {
                this.available_shifts_dropdown = this.$store.getters['shifts/dropdown'];
                if (this.available_shifts_dropdown && this.available_shifts_dropdown.length) {
                    this.activityGuidance.shift_id = this.available_shifts_dropdown[0].id;
                }
            });
        },
        getActivityDropDowns () {
            this.$store.dispatch('activities/list').then(() => {
                this.available_activities_dropdown = this.$store.getters['activities/list'];
                if (this.available_activities_dropdown && this.available_activities_dropdown.length) {
                    this.activityGuidance.activity_id = this.available_activities_dropdown[0].id;
                }
            });
        },
        getGuidanceDropDowns () {
            this.$store.dispatch('guidances/list').then(() => {
                this.available_guidances_dropdown = this.$store.getters['guidances/list'];
                if (this.available_guidances_dropdown && this.available_guidances_dropdown.length) {
                    this.activityGuidance.guidance_id = this.available_guidances_dropdown[0].id;
                }
            });
        },
        getWorkplaceDropDowns () {
            this.$store.dispatch('workplaces/list').then(() => {
                this.available_workplaces_dropdown = this.$store.getters['workplaces/dropdown'];
                if (this.available_workplaces_dropdown && this.available_workplaces_dropdown.length) {
                    this.activityGuidance.workplace_id = this.available_workplaces_dropdown[0].id;
                }
            });
        },
        getActivityTariffDropDowns () {
            this.$store.dispatch('activityTariffs/list').then(() => {
                console.log(this.$store.getters);
                this.available_activity_tariffs_dropdown = this.$store.getters['activityTariffs/list'];
                if (this.available_activity_tariffs_dropdown && this.available_activity_tariffs_dropdown.length) {
                    this.activityGuidance.activity_tariff_id = this.available_activity_tariffs_dropdown[0].id;
                }
            });
        },
        goBack () {
            this.$router.push({ name: 'Activity Guidances List' });
        },
    },
};
</script>
